import RequirePalmettoFinanceUser from '@/components/auth/RequirePalmettoFinanceUser';
import { RequirePayoutsAccountingSettingsUser } from '@/components/auth/RequirePayoutsAccountingSettingsUser';
import { Box, Button } from '@palmetto/palmetto-components';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { OrganizationNode } from '../../../../types/Organizations';

interface PaymentCardHeaderProps {
  href?: string;
  isPhone?: boolean;
  organization?: OrganizationNode;
  onClick?: () => void;
  cardTitle: string;
  isInherited?: boolean;
  orgHasSignatoryEmails?: boolean;
}

const PaymentCardHeader = ({
  organization,
  isPhone,
  href,
  onClick,
  cardTitle,
  isInherited,
  orgHasSignatoryEmails,
}: PaymentCardHeaderProps) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => {
    if (href) {
      navigate(href);
    } else {
      onClick?.();
    }
  }, [href, navigate, onClick]);

  return (
    <Box childGap="lg" padding="lg" alignItems="center" direction="row" justifyContent="space-between">
      <Box as="h3" fontWeight="medium" fontSize="md">
        {cardTitle}
      </Box>
      {isInherited && (
        <Box style={{ flex: '1' }} alignItems={'center'}>
          Payment Plan is inherited from parent organization
        </Box>
      )}
      <RequirePalmettoFinanceUser>
        <RequirePayoutsAccountingSettingsUser>
          {organization && (
            <Button
              variant="secondary"
              tone="neutral"
              size="sm"
              aria-label="Edit Payment Schedule"
              iconPrefix="pencil"
              onClick={handleClick}
              disabled={!orgHasSignatoryEmails}
            >
              {!isPhone && 'Edit'}
            </Button>
          )}
        </RequirePayoutsAccountingSettingsUser>
      </RequirePalmettoFinanceUser>
    </Box>
  );
};

export default PaymentCardHeader;
